<template>
  <div>
    <Tigan :topic="topic" :index="index">
      <div v-html="topic.tiGan.html" />
    </Tigan>
    <!-- 判断题 -->
    <template v-if="topic.type === 3">
      <div class="topic-box panduan-box" v-for="(item, index) in panduanList" :key="index">
        <template v-if="topic.judgeType === 1">
          <svg-icon :icon="item" />
        </template>
        <template v-else>
          {{ item }}
        </template>
      </div>
    </template>
    <!-- 选择题 -->
    <div v-else class="topic-box topic-option" v-for="(opt, index) in topic.options" :key="index">
      <span class="opt-index">{{ optIdxNames[index] }}.</span>
      <div class="option" v-html="opt.html" />
    </div>
    <div class="answer-wrap">
      正确答案：
      <template v-if="topic.judgeType === 1">
        <div v-for="(item, index) in answers" :key="index">
          <svg-icon :icon="item" />
        </div>
      </template>
      <template v-else>
        <div v-for="(item, index) in answers" v-html="item" :key="index" />
      </template>
    </div>
  </div>
</template>
<script>
import Tigan from './Tigan.vue'
export default {
  components: {
    Tigan
  },
  props: {
    topic: Object,
    index: Number
  },
  data() {
    return {
      optIdxNames: {
        0: 'A',
        1: 'B',
        2: 'C',
        3: 'D',
        4: 'E',
        5: 'F',
        6: 'G',
        7: 'H'
      }
    }
  },
  computed: {
    panduanList() {
      const { type } = this.topic
      if (type === 3) {
        return this.panduanTxt()
      }
      return []
    },
    answers() {
      const { type, answers } = this.topic
      if (answers && answers.length) {
        if (type === 3) {
          const optArr = this.panduanTxt()
          return answers.map(item => {
            const answer = Number(item.text)
            // 错
            if (answer === 0) {
              return optArr[1]
            }
            // 对
            return optArr[0]
          })
        }
        return answers.map(item => item.html)
      }
      return ''
    }
  },
  methods: {
    panduanTxt() {
      const { judgeType } = this.topic
      const judgeMap = {
        '-1': ['对', '错'],
        1: ['correct', 'close'],
        2: ['T', 'F'],
        3: ['R', 'W']
      }
      return judgeMap[judgeType] || ['对', '错']
    }
  }
}
</script>
<style lang="less" scoped>
.topic-box {
  padding: 12px 14px;
  background: #fff;
  border-radius: 6px;
  margin-top: 10px;
  &.panduan-box {
    display: flex;
    align-items: center;
    :deep(svg) {
      fill: #505873;
      font-size: 16px;
    }
  }
}
.topic-option {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #505873;
  .opt-index {
    margin-right: 4px;
  }
}
.xuanze-wrap {
  overflow-y: auto;
}
.answer-wrap {
  display: inline-flex;
  color: #505873;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  margin-top: 10px;
}
</style>